import { Link } from "react-router-dom";
import Header from "./Header";

const ErrorPage = () => {
  return (
    <div className="App flex flex-col">
      <Header></Header>
      <div className="flex flex-col ml-4 mt-6 items-center">
        <p className="mb-4">Sorry, αυτό που ήθελες δεν βρέθηκε.</p>
        <p>
          Δοκίμασε να δεις στη <Link to="/gallery">Gallery</Link>
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
